import React, { useEffect } from "react";
import UpComeingPaymentsListing from "./UpComeingPaymentsListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/UpComeingPaymentsSlice";
import { useGetAllUpComeingInstallmentsQuery } from "src/services/UpComeingPaymentsServices";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import moment from "moment";

type Props = {};

const UpComeingPaymentsListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading , dateFilter , batches } =
    useSelector((state: RootState) => state.upComeingPayments);

  const { data, isFetching, isLoading } = useGetAllUpComeingInstallmentsQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["studentName" , "amount"],
    page: page,
    filterBy: [ {
        fieldName: "batchId",
        value: batches?.value,
      },],
    orderBy: "dueDate",
    orderByValue: 1,
    dateFilter: {
      dateFilterKey: "dueDate",
      startDate: dateFilter?.start_date
      ? moment(dateFilter?.start_date).format("YYYY-MM-DD")
      : "",
    endDate: dateFilter?.end_date
      ? moment(dateFilter?.end_date).format("YYYY-MM-DD")
      : "",
    },
    isPaginationRequired: true,
  });

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isFetching, data]);

  const columns: columnTypes[] = [
    {
      field: "dueDate",
      headerName: "Due-Date",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <div>
          <div className="text-slate-700 font-medium">
            {formatedDateTimeIntoIst(row?.dueDate, "DD MMM yyyy")}
          </div>
        </div>
      ),
    },
    {
      field: "studentName",
      headerName: "Student Name",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <div className="capitalize">{row?.studentName} </div>
      ),
    },
    { field: "batchName", headerName: "batch-Name", flex: "flex-[1_1_0%]" },
    {
      field: "amount",
      headerName: "Amount",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <div className="font-semibold">₹{row?.amount} </div>
      ),
    },
    {
      field: "remark",
      headerName: "Remark",
      flex: "flex-[1_1_0%]",
      extraClasses: "py-1",
      renderCell: (row: any) => <div>{row?.remark} </div>,
    },
  ];

  return (
    <div>
      <UpComeingPaymentsListing
        columns={columns}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
    </div>
  );
};

export default UpComeingPaymentsListingWrapper;
